export default function getLineWidth(linewidth?: string): number {
  switch (linewidth) {
    case "thin":
      return 1;
    case "thick":
      return 3;
    case "regular":
    default:
      return 2;
  }
}
